import React from 'react';
import type { components } from '../../../../types/learnerApi';

type Config = components['schemas']['SanitizedBooleanConfig'];

export interface BooleanAnswer {
  value: boolean;
}

export interface BooleanTrueFalseViewProps {
  item: { id: string; points?: number; config: Config };
  mode: 'learner' | 'preview';
  value?: BooleanAnswer;
  onChange?: (value: BooleanAnswer) => void;
  disabled?: boolean;
}

const BooleanTrueFalseView: React.FC<BooleanTrueFalseViewProps> = ({
  item,
  mode,
  value,
  onChange,
  disabled,
}) => {
  const select = (v: boolean) => {
    if (disabled || mode === 'preview') return;
    onChange?.({ value: v });
  };

  return (
    <div className="space-y-4">
      {/* In learner mode the parent QuestionCard renders the prompt; in
          preview mode there's no parent prompt, so render it here. */}
      {mode === 'preview' && (
        <p className="font-medium text-text-primary">{item.config.question}</p>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {([true, false] as const).map((v) => {
          const active = value?.value === v;
          return (
            <button
              key={String(v)}
              type="button"
              onClick={() => select(v)}
              disabled={disabled}
              className={`flex items-center gap-3 pl-4 sm:pl-5 pr-3 py-2.5 rounded-full border text-sm font-medium transition-colors select-none ${
                active
                  ? 'border-primary-500 bg-primary-50/80 dark:bg-primary-900/25 text-primary-700 dark:text-primary-200'
                  : 'border-border-secondary bg-surface-primary hover:border-primary-300 text-text-primary'
              } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
            >
              <span className="flex-1 text-left truncate">{v ? 'True' : 'False'}</span>
              <span
                className={`relative shrink-0 w-5 h-5 rounded-full border-[1.5px] transition-colors ${
                  active ? 'border-primary-500' : 'border-text-secondary'
                }`}
              >
                {active && (
                  <span className="absolute inset-[3px] rounded-full bg-primary-500" />
                )}
              </span>
            </button>
          );
        })}
      </div>

      {item.points != null && (
        <p className="text-xs text-text-tertiary">
          {item.points} pt{item.points !== 1 ? 's' : ''}
        </p>
      )}
    </div>
  );
};

export default BooleanTrueFalseView;
